module.exports = __webpack_public_path__ + "2.jpg?dae9b35d5dd4f564f309c0dbb85fd5b1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2.jpg
// module id = 21
// module chunks = 0